// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import VerticalRightOutlinedSvg from "@ant-design/icons-svg/es/asn/VerticalRightOutlined";
import AntdIcon from '../components/AntdIcon';

var VerticalRightOutlined = function VerticalRightOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: VerticalRightOutlinedSvg
  }));
};

VerticalRightOutlined.displayName = 'VerticalRightOutlined';
export default React.forwardRef(VerticalRightOutlined);